export enum ReportType {
    WRONG_FUEL = "WRONG_FUEL",
    STATION_CLOSED = "STATION_CLOSED"
}

export const ReportTypeValues = Object.values(ReportType);